export const formatFormData = (files, contactListName, campaignName, selectedClient) => {
    const dataToSend = new FormData()
    files.forEach((file) => dataToSend.append('file', file, file.name))
    dataToSend.append('contactListName', contactListName)
    dataToSend.append('campaignName', campaignName)
    dataToSend.append('client', selectedClient)

    return dataToSend
}